import axios from "axios";
import { Middleware } from 'redux';
import { IChat } from "types/IChat"; 
import * as actions from '../api';

const api: Middleware<{}, IChat>  = ({dispatch}) => next => async action => {
    if(action.type !== actions.apiCallBegan.type) return next(action);

    const {url, headers, method, data, onSuccess, onError, resolve, reject} = action.payload;

    try {
        const response: any = await axios.request({url, headers, method, data})
        dispatch({type: onSuccess, payload: response['data']});

        if(resolve) {
            resolve(response['data'])
        }
        
    }
    catch(e) {
        //dispatch({type: onError, payload: e});
        if(reject) {
            reject(e)
        }
    }
}

export default api;